import React, { useEffect, useState } from "react";
import { DateRangePicker, DateRange } from "@matharumanpreet00/react-daterange-picker";
import { UilCalendar } from '@iconscout/react-unicons';
import "./DatePicker.css"
import { formatDate, getEndOfWeek, getStartOfWeek } from "../../Functions/Functions";

// initialRange lets a caller opt out of the "this week" default (Orders.js
// passes {startDate: null, endDate: null} so it shows every order until a
// range is actually picked, instead of silently filtering to "this week"
// with no visible indication a filter was active). Dashboard/Analytics
// keep the current-week default by not passing it.
const DatePicker = ({ onDateRangeChange, initialRange }) => {
  const [open, setOpen] = useState(false);

  const handleRangeChange = (range) => {
    setDateRange(range);
    onDateRangeChange(range); // Pass data to parent
  };

  const now = new Date();
  const [dateRange, setDateRange] = useState(
    initialRange || {
      startDate: getStartOfWeek(now),
      endDate: getEndOfWeek(now),
    }
  );

  return (
    <div className="date-range-picker">
        <div>
            <div className="date-inputs">
                <div onClick={()=>setOpen(!open)} className="date-input">
                    <h4>{formatDate(dateRange.startDate) || "Toutes les dates"}</h4>
                    <UilCalendar/>
                </div>
                <h3>-</h3>
                <div onClick={()=>setOpen(!open)} className="date-input">
                    <h4>{formatDate(dateRange.endDate) || "Toutes les dates"}</h4>
                    <UilCalendar/>
                </div>
            </div>
            <DateRangePicker
                open={open}
                onChange={handleRangeChange}
            />
        </div>
    </div>
  );
};

export default DatePicker;
